import React from "react";
import AddMemberButton from "./AddMemberButton";
import AverageTimeSpentButton from "./AverageTimeSpanButton";

function Section({ users, title, roles }) {
    return (
        //section
        <div class="relative flex items-center h-24 max-w-screen-1xl justify-between bg-[#9b9b9b] z-[1] mt-[70px]">
            {/*  section Title */}
            <div class="text-white font-sans text-3xl ml-[385px] whitespace-nowrap">
                <span>{title}</span>
            </div>
            {/* create,sort,filter component */}
            
            {roles === "Admin" && (
                <div class="flex justify-center w-auto h-auto ml-auto mr-[1%] space-x-[20px]">
                    <AverageTimeSpentButton users={users}/>
                    <AddMemberButton />

                </div>
            )}
        </div>
    );
}

export default Section;